import { action, thunk, persist, computed } from 'easy-peasy';
import callApi from '../helpers/ApiAction';

const state = {
  users: {
    list: [],
  },
};

const selectors = {
  usersDropdown: computed(state => state.users.list.map(g => ({
    key: `user-${g.id}`,
    text: g.name,
    value: g.id,
  })))
};

const actions = {
  fetchUsers: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: `users`,
      method: 'GET'
    });

    const json = await res.json();

    actions.setUsersList(json);
  }),
  setUsersList: action((state, payload) => {
    const {
      data: { users }
    } = payload;

    state.users.list = users;
  }),
};

export default persist(
  {
    ...state,
    ...selectors,
    ...actions
  },
);
